<template>
  <JoszakiCard class="mt-12 mx-auto mb-2 relative min-w-[250px] !pt-10">
    <div class="absolute w-16 h-16 left-1/2 ml-[-36px] top-[-30px]">
      <figure class="image h-full">
        <img
          v-lazy-load :data-src="
            $helpers.getProfilePictureThumbnailUrl(
              personPublicProfile
                ? personPublicProfile.profilePhotoId
                : undefined
            )
          "
          class="rounded-full"
          alt="Joszaki logo"
          @error="$helpers.noImage"
        />
      </figure>
    </div>
    <div v-if="!personPublicProfile" class="text-center mb-4">
      <i18n path="requestTender.heroBlock.title" tag="p">
        <template #free>
          <span class="font-bold">{{
            $t("requestTender.heroBlock.free")
          }}</span>
        </template>
        <template #rated>
          <span class="font-bold">{{
            $t("requestTender.heroBlock.rated")
          }}</span>
        </template>
      </i18n>
      {{ $t("requestTender.heroBlock.subTitle") }}
    </div>

    <div v-if="personPublicProfile" class="text-center">
      <div>
        <span class="font-bold capitalize mr-1">{{
          $t("requestTender.heroBlock.free")
        }}</span>
        {{ $t("requestTender.heroBlock.rtf") }}
      </div>
      <span class="text-2xl">{{ personPublicProfile.name }}</span>
      <div>{{ $t("branding.fromMate") }}</div>
    </div>
    <div
      v-else-if="lastCity && lastProfession"
      class="leading-snug text-2xl text-center"
    >
      {{
        $t("requestTender.heroBlock.withCityAndProfession.subtitle", {
          city: lastCity.name.toLowerCase(),
          profession: lastProfession.objective.toLowerCase(),
        })
      }}
      <a class="text-sm text-primary" @click="$emit('deleteCookie')"
        >({{ $t("requestTender.heroBlock.withCityAndProfession.change") }})</a
      >
    </div>
    <div v-else class="leading-snug text-center">
      <i18n path="requestTender.heroBlock.generic.title">
        <template #forYou>
          <span class="font-bold">{{
            $t("requestTender.heroBlock.generic.forYou")
          }}</span>
        </template>
      </i18n>
    </div>
  </JoszakiCard>
</template>

<script>
export default {
  props: {
    personPublicProfile: {
      type: Object,
      default: null,
    },
    lastCity: {
      type: Object,
      default: null,
    },
    lastProfession: {
      type: Object,
      default: null,
    },
  },
};
</script>
